export {default as config} from "../config/config";



// WEBPACK FOOTER //
// ./src/services/external.js